// extracted by mini-css-extract-plugin
export default {"footer":"index_footer__y-oGX","pagination":"index_pagination__5QYfB","buttonWrapper":"index_buttonWrapper__GYC0s","content":"index_content__tCkRZ","price":"index_price__Vw4A-"};